/**
 *
 * NotesLanding
 *
 */

import { mapState, mapGetters, mapMutations } from 'vuex';
//import _ from 'lodash';
//import $ from 'jquery';

export default {
  name: 'NotesLandingMenu',

  computed: {
    ...mapState('Notes', {
      ms_isGeneratingPdf: 'isGeneratingPdf',
    }),

    ...mapGetters('Notes/NotesLanding', {
      mg_lstNotesGroupActive: 'lstNotesGroupActive',
      mg_lstNotesGroupDisabled: 'lstNotesGroupDisabled',
      mg_currentCourse: 'currentCourse',
    }),
  },

  methods: {
    ...mapMutations('Notes/NotesLanding', {
      mm_SET_COURSE_IDX: 'SET_COURSE_IDX',
    }),

    selectCourse(courseIdx) {
      this.mm_SET_COURSE_IDX(courseIdx);
      this.$emit('select-course');
    },
  },
};
